<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-button @click="onSearch" variant="info" class="p-2">
      <span v-if="!this.bButtonIcon">Buscar</span>
      <i v-if="this.bButtonIcon" class="zmdi zmdi-search"></i>
    </b-button>
  </div>
  <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" dialog-class="modal-search">
       <div class="modal-body">
          <form @submit.stop.prevent="searching">
              <b-row>
              <b-col>
              <b-form-group id="input-group-2"
              label="Ingrese texto a buscar:" label-for="input-2">
                  <div class="col-md-12 d-inline-flex align-items-center mb-5">
                    <b-form-input
                    id="input-2"
                    class="mr-2"
                    :state="($v.resoursetosearch.$dirty && submitted)? !$v.resoursetosearch.$error : null"
                    v-model.trim="resoursetosearch">
                    </b-form-input>
                    <b-button size="md" variant="info" type="submit">Buscar</b-button>
                  </div>
                  <b-table hover :items="resources"
                        :fields="fields"
                        sticky-header >
                    <template v-slot:cell(PLANTILLA)="data">
                      {{ data.item.PLANTILLA[languages.indexOf(languageGlobal)].TEXTO }}
                    </template>
                    <template v-slot:cell(actions)="row">
                      <b-button size="sm" variant="info" @click="selected(row.item)">
                        Seleccionar
                      </b-button>
                    </template>
                  </b-table>
              </b-form-group>
              </b-col>
            </b-row>
          </form>
        </div>

        <template v-slot:modal-footer>
          <div class="col-md-12 d-flex justify-content-end mb-3">
            <b-button @click="onCreate" variant="success" class="p-2">
              <span> <i class="zmdi zmdi-plus"></i> Crear recurso</span>
            </b-button>
          </div>
        </template>
    </b-modal>
</div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  props: ['idModal', 'bButtonIcon'],
  data() {
    return {
      submitted: false,
      resoursetosearch: null,
      resources: [],
      itemSelected: {
        ID: null,
        NOMBRE: null,
        SUB: null,
        FORMULAS_ID: null,
        PLANTILLAS_ID: null,
        CC: null,
        CU: null,
      },
      fields: [
        { key: 'NOMBRE', label: 'Nombre' },
        { key: 'SUB', label: 'Subproblema' },
        { key: 'FORMULA_NOMBRE', label: 'Fórmula' },
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      infoModal: {
        id: this.idModal,
        title: 'Buscador de enunciados de fórmula',
      },
    };
  },
  validations: {
    resoursetosearch: {
      required,
      minLength: minLength(2),
    },
  },
  methods: {
    onSearch() {
      this.resources = [];
      this.resoursetosearch = null;
      this.itemSelected.ID = null;
      this.itemSelected.NOMBRE = null;
      this.itemSelected.SUB = null;
      this.itemSelected.FORMULAS_ID = null;
      this.itemSelected.PLANTILLAS_ID = null;
      this.itemSelected.CC = null;
      this.itemSelected.CU = null;
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    async searching() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      this.resources = [];
      this.loading = true;
      const response = await this.axios.get('statementformula/searching', {
        params: {
          resoursetosearch: this.resoursetosearch,
        },
      });
      this.resources = response.data;
      this.loading = false;
    },
    reset() {
      this.resources = [];
      this.resoursetosearch = null;
    },
    selected(item) {
      this.$emit('selected', item);
      this.$root.$emit('bv::hide::modal', this.infoModal.id);
      this.reset();
    },
    onCreate() {
      const routeData = this.$router.resolve({ name: 'statementformula' });
      window.open(routeData.href, '_blank');

      setTimeout(() => {
        const bc = new BroadcastChannel('new_resource_statements_formula_open');
        bc.postMessage({});
      }, 500);
    },
  },
  mounted() {
    const self = this;
    const bc = new BroadcastChannel('new_resource_statements_formula');
    bc.onmessage = (ev) => {
      self.resources.push(ev.data);
    };
  },
};
</script>
